import React, { type ReactNode } from 'react';
import { Paper, Typography, Box, Tooltip } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';
import { metricSummaryTooltipProps } from '../../constants/metricTooltips';

interface FeedbackCardProps {
  total: number;
  positive: number;
  negative: number;
  color: string;
  tooltip?: ReactNode;
}

export const FeedbackCard: React.FC<FeedbackCardProps> = ({
  total,
  positive,
  negative,
  color,
  tooltip,
}) => {
  const paper = (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        height: '100%',
        border: `1px solid ${SEARCE_COLORS.border}`,
        borderRadius: 2,
        borderLeft: `4px solid ${color}`,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          color: SEARCE_COLORS.textSecondary,
          mb: 1.5,
          fontSize: '0.875rem',
          lineHeight: 1.4,
        }}
      >
        Total Feedback(
        <Box component="span" sx={{ fontWeight: 700, color: SEARCE_COLORS.textPrimary }}>
          {total}
        </Box>
        )
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, flexWrap: 'wrap' }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: SEARCE_COLORS.success,
            fontSize: '2.25rem',
            lineHeight: 1.2,
          }}
        >
          {positive}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: SEARCE_COLORS.textSecondary,
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: 1.4,
            textTransform: 'capitalize',
          }}
        >
          Positive
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: SEARCE_COLORS.gray_400,
            fontSize: '1.25rem',
            fontWeight: 400,
            lineHeight: 1.2,
          }}
        >
          /
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: SEARCE_COLORS.error,
            fontSize: '2.25rem',
            lineHeight: 1.2,
          }}
        >
          {negative}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: SEARCE_COLORS.textSecondary,
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: 1.4,
            textTransform: 'capitalize',
          }}
        >
          Negative
        </Typography>
      </Box>
    </Paper>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} {...metricSummaryTooltipProps}>
        <Box sx={{ width: '100%', display: 'block' }}>{paper}</Box>
      </Tooltip>
    );
  }

  return paper;
};
